import Box from "@mui/material/Box";
import EmptyProjectView from "./EmptyProjectView";
import ProjectContainer from "./ProjectContainer/ProjectContainer";
import { projects } from "./projects/projects";
const ProjectView = () => {
	document.title = "Projects | Prakash";
	return (
		<>
			{projects.map((x) => (
				<ProjectContainer
					name={x.name}
					label={x.label}
					description={x.description}
					appUrl={x.appUrl}
					devUrl={x.devUrl}
					key={x.name}
				/>
			))}
		</>
	);
};
export default ProjectView;
